import React, { Component } from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar';
import Navbars from '../components/navbars/Navbars';
import PackageOrderSummary from '../components/register_steps/PackageOrderSummary';
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import ScrollTopNavbar from '../components/navbars/ScrollTopNavbar'
import * as Cookies from "es-cookie";
import { withRouter } from 'react-router-dom';
const COUPN_VALIDATION = gql`
  mutation($student_user_exam_id: String,
$plan_id: Int,
$referral_code: String,
$type: String,
$amount: String) {
    validateReferralCode(student_user_exam_id: $student_user_exam_id, plan_id: $plan_id, referral_code: $referral_code,type: $type, amount: $amount){
        referral_id
        applied_amount
        status
        desc
        type
        value
    } 
  }
`;
class MockTestOrderSummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: "wrapper sidebar-enable",
            couponob: "",
            submitError4: "",
            headerBottomImg: {
                Img: require('../../images/mocktext-img.png'),
                Title: "Mock Test Order Summary",
                width: 150,
                helpImg: require('../../images/Ask_me_for_Help.gif')
            }
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
         if (toggled === "wrapper") {
             this.setState({toggled:"wrapper sidebar-enable"});
             Cookies.set("toggle", "wrapper sidebar-enable");
         } else {
             this.setState({toggled:"wrapper"});
             Cookies.set("toggle", "wrapper");
         }
     };
    coupnValidation = (e, data) => {
        e.preventDefault();
        if (data != "") {

            this.coupnval(
                Cookies.get("examid"),
                parseInt(this.props.history.location.state.data.id),
                data,
                "mock_test",
                this.props.history.location.state.data.amount.toString()
            ).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError4: error.graphQLErrors.map(x => x.message)
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });

        } else {
            this.setState({ submitError4: "Please fill COUPON ID" });
        }


    }
    coupnval = async (student_user_exam_id,
        plan_id,
        referral_code,
        type,
        amount) => {
        await this.props.coupnval({
            variables: {
                student_user_exam_id,
                plan_id,
                referral_code,
                type,
                amount
            },
            update: (store, { data }) => {
                //console.log("coupnvaldata", data);
                if (data.validateReferralCode) {
                    //Cookies.set("coupnvalmob", data.validateReferralCode);
                    this.setState({
                        couponob: data.validateReferralCode,
                        submitError4: ""
                    });

                }
            }
        });
    };
    render() {
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                <AsideNavbar onClick={() => this.menuToggler()}/>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">

                        <section className="student-package">
                            <Container>

                                <PackageOrderSummary
                                    type="mocktest"
                                    coupnValidation={this.coupnValidation}
                                    stateData={this.state}
                                    locgetData={this.props.history.location.state != undefined ? this.props.history.location.state : ""}
                                />


                            </Container>
                        </section>


                    </div>
                </div>
            </div>

            // <div className="student main-wrapper">
            //     <div className="student header-area mock-tests-eries-topnavbar">
            //         <ScrollTopNavbar headerBottom={this.state.headerBottomImg} onClick={() => this.menuToggler()} />
            //     </div>
            //     <AsideNavbar onClick={() => this.menuToggler()}/>
            //<div className="student-overlay" onClick={() => this.menuToggler()} />
            //     <div className="content-wrapper">
            //         <PackageOrderSummary
            //             type="mocktest"
            //             coupnValidation={this.coupnValidation}
            //             stateData={this.state}
            //             locgetData={this.props.history.location.state != undefined ? this.props.history.location.state : ""}
            //         />
            //     </div>
            // </div>

        )
    }
}

export default withRouter(
    graphql(COUPN_VALIDATION, {
        name: "coupnval"
    })(MockTestOrderSummary)); 
